'use strict';

var UserManagementPanelController = function UserManagementPanelController($scope, UserManagementConstants) {
  $scope.mode = null;
  $scope.$on('user-management:modeChanged', function (event, mode) {
    $scope.mode = mode;
  });
  $scope.isUserScreen = function () {
    return $scope.mode === UserManagementConstants.SCREEN_VALUE.MANAGE_USERS;
  };
  $scope.isRoleScreen = function () {
    return $scope.mode === UserManagementConstants.SCREEN_VALUE.ROLE_MANAGEMENT;
  };
  $scope.isDefaultWorkflowSettingsScreen = function () {
    return $scope.mode === UserManagementConstants.SCREEN_VALUE.WORKFLOW_DEFAULT_SETTINGS;
  };
  $scope.isDefaultDateTimeSettingsScreen = function () {
    return $scope.mode === UserManagementConstants.SCREEN_VALUE.DATE_TIME_NUMBER_DEFAULT_FORMAT;
  };
};
UserManagementPanelController.$inject = ['$scope', 'UserManagementConstants'];
module.exports = UserManagementPanelController;